
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 1.667c0-.46.373-.834.833-.834h.834a.833.833 0 010 1.667h-.834A.833.833 0 015 1.667zm4.989 1.666H1.667a.833.833 0 100 1.667h6.776l-.757 1.136L6.25 7.57 4.756 6.077a.833.833 0 10-1.179 1.179L5.072 8.75l-2.328 2.327a.833.833 0 101.179 1.179L6.25 9.928l1.494 1.494a.833.833 0 001.179-1.178L7.429 8.75l1.494-1.494a.834.834 0 00.104-.127l1.419-2.13h1.22a.833.833 0 000-1.666H9.99zm3.217 4.424a1.25 1.25 0 011.088 0c.298.144.46.395.54.53.085.142.171.323.256.5l3.995 8.353a.833.833 0 11-1.503.72L16.214 15h-4.928l-1.368 2.86a.833.833 0 11-1.503-.72l3.982-8.325.013-.027c.085-.178.171-.359.255-.5.08-.136.243-.387.541-.531zm-1.123 5.576h3.334L13.75 9.848l-1.667 3.485z","fill":"#fff","fill-opacity":".7"}})])
          )
        }
      }
    